module.exports = __webpack_public_path__ + "img/IT0000391013404.a412046f.png";